/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component, createRef } from 'react';

import { connect } from 'react-redux';
import { Form, Row, Col, Spinner, Button } from 'react-bootstrap';

import { LocationService, CityAndStateService } from 'shared/services';

import './LocationsList.scss';
import { image_thumbnail } from 'shared/images/images';
import validators from 'shared/validators';
import { ArrayValueReorder } from 'shared/modifiers';
import store from 'features/store';
import { convertToMaintainData, disablePreviousState, getMaintainData, locationList } from 'shared/settings/stateMaintain';
import { isAuthorized } from 'shared/settings/auth';
import { bannerImage } from 'shared/utils/utils';
import { Helmet } from 'react-helmet';
import { ADSENSE } from 'shared/settings/config';
import { Adsense } from 'shared/utils/Adsense';

/**


@Author Karthik

@param

@return html code for locations list

**/

class LocationsList extends Component {
    constructor(props) {
        super(props);
        this.moreOptionsPopoverRef = createRef(); // More options popover ref
        this.scrollRef = createRef();

        this.locationFilterForm = {
            name: { value: 'name-a-z', error: '', validators: [validators.required()] },
            location: { value: 'All', error: '', validators: [validators.required()] },
            city: { value: 'All', error: '', validators: [validators.required()] },
            zipcode: { value: '', error: '', validators: [validators.equalToLength(5)] },
            loctitle: { value: '', error: '', validators: [validators.required()] },
            miles: { value: '5', error: '', validators: [validators.required()] }
        };

        this.state = {
            pageLoading: true,
            locationList: [],
            stateList: [],
            nextList: null,

            /* Options popover */
            optionsPopoverShow: false,
            optionsPopoverTarget: false,
            disableOptionPopoverClose: false,

            /* To handle responsive */
            innerWidth: window.innerWidth,
            filterLoading: false,

            /* location filter form */
            locationFilterForm: Object.assign({}, this.locationFilterForm),
            formValid: true,
            loaderForMore: false,
            cityList: [],
            clearLoading: false,
            filterApplied: false,
            isVisible: false,
            pageClientWidth: 16,
            scrollTo: 0,
            locationInProgress: {},
            favoriteLocations: [],
            updateAllFavoriteLocations: false,
            saleCount: false,
        }
    }

    componentDidMount() {
        this.getLocationList();
        window.addEventListener('resize', this.resizeHandle);
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.user) !== JSON.stringify(this.props.user)) {
            if (isAuthorized()) {
                this.getFavoriteLocation(true);
            } else {
                this.setState({
                    favoriteLocations: []
                });
            }
        }
    }

    /* checks whether the input is valid or not */
    onInputValidation = (event, formName = "locationFilterForm") => {
        let controlError = '';

        /* checks all the validators for the control */
        for (let validator of this.state[formName][event.target.name].validators) {
            controlError = validator(event.target.value);
            if (controlError) break;
        }

        if (event.target.name === 'zipcode') {
            if (isNaN(Number(event.target.value)))
                event.target.value = '';
        }


        /* sets the state of the control and form validity */
        this.setState({
            [formName]: {
                ...this.state[formName],
                [event.target.name]: {
                    ...this.state[formName][event.target.name],
                    value: event.target.value,
                    valid: !Boolean(controlError),
                    error: controlError
                }
            }
        },
            () => {
                /* check form validity */
                if (controlError)
                    this.setState({ formValid: false });
                else {
                    let formValid = true;
                    for (let control of Object.keys(this.state[formName])) {
                        if (!this.state[formName][control].valid) {
                            formValid = false;
                            break;
                        }
                    }
                    this.setState({ formValid: formValid });
                }

                if (event.target.name === "location") {
                    this.setState({
                        cityList: [],
                        [formName]: {
                            ...this.state[formName],
                            city: {
                                ...this.state[formName]["city"],
                                value: "All",
                                valid: false,
                                error: ""
                            }
                        }
                    });
                    if (event.target.value !== "All") {
                        this.getCityList(event);
                    }
                }
            });
    }

    getLocationList = () => {
        const previousData = getMaintainData(locationList);
        if (previousData && this.props.previousPath.component === "SaleListForLocation") {
            disablePreviousState();
            const locationFilterForm = JSON.parse(JSON.stringify(previousData.locationFilterForm));
            delete previousData['locationFilterForm'];
            if (isAuthorized()) {
                this.getFavoriteLocation();
            }
            this.setState({
                ...previousData,
                locationFilterForm: {
                    ...this.state.locationFilterForm,
                    name: {
                        ...this.state.locationFilterForm.name,
                        value: locationFilterForm.name.value
                    },
                    location: {
                        ...this.state.locationFilterForm.location,
                        value: locationFilterForm.location.value
                    },
                    city: {
                        ...this.state.locationFilterForm.city,
                        value: locationFilterForm.city.value
                    },
                    zipcode: {
                        ...this.state.locationFilterForm.zipcode,
                        value: locationFilterForm.zipcode.value
                    },
                    loctitle: {
                        ...this.state.locationFilterForm.loctitle,
                        value: locationFilterForm.loctitle.value
                    },
                    miles: {
                        ...this.state.locationFilterForm.miles,
                        value: locationFilterForm.miles.value
                    }
                },
                pageLoading: false
            }, () => {
                this.scrollRef.current.scrollTo({ top: this.state.scrollTo, left: 0 });
                store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: "locationList" } });
            });
        } else {
            if (isAuthorized()) {
                this.getFavoriteLocation();
            }
            store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: "locationList" } });
            const postData = {
                "sort": [{ "field": "title", "direction": "asc" }],
                "page": this.state.nextList ? { "size": 48, next: this.state.nextList } : { 'size': 48 },
                "field": ["id", "title", "contactname", "email", "salecount", "phone", "imageurl", "locationstatecode", "locationcode"]
            };
            LocationService.getLocationList(postData).then(
                locationList => {

                    CityAndStateService.getStateList().then(
                        stateList => {
                            const temp = locationList.data.page && locationList.data.page.keyset && locationList.data.page.keyset.next ? locationList.data.page.keyset.next : null;
                            const tempStateList = ArrayValueReorder(stateList.data.data, 'state');
                            // getGoogleAdData(locationList.data.data, 8);
                            this.setState({
                                locationList: locationList.data.data,
                                stateList: tempStateList,
                                pageLoading: false,
                                nextList: temp,
                                clearLoading: false,
                            });
                        }
                    ).catch((error) => {
                        // TODO: Error message handle
                        this.setState({
                            pageLoading: false
                        });
                    });
                }
            ).catch((error) => {
                // TODO: Error message handle
                this.setState({
                    pageLoading: false
                });
            });
        }
    }

    getCityList = (event) => {
        CityAndStateService.getCityList(event.target.value).then(
            cityList => {
                this.setState({
                    cityList: ArrayValueReorder(cityList.data.data, 'city')
                })
            }
        ).catch(error => error);
    }

    getFavoriteLocation = (updateAll = false) => {
        this.setState({
            updateAllFavoriteLocations: updateAll
        }, () => {
            const postData = {
                "sort": [{ "field": "id", "direction": "asc" }],
                "field": ["id", "locationid", "buyerid"],
                "page": { "size": 999 }
            };
            if (isAuthorized()) {
            LocationService.getFavoriteLocation(postData).then(res => {
                const data = res.data.data;
                this.setState({
                    favoriteLocations: data,
                    updateAllFavoriteLocations: false
                });
            }).catch(error => {
                this.setState({
                    favoriteLocations: [],
                    updateAllFavoriteLocations: false
                });
            });
            }
        });

    }


    /* Called when more options button hover */
    moreOptionsPopoverHanlde = (event, flag) => {

        /* Mouse enter */
        if (event.type === "mouseenter") {
            if (flag === 'Popover-Div') {
                this.setState({ disableOptionPopoverClose: true });
            } else {
                this.setState({ optionsPopoverShow: true, optionsPopoverTarget: event.target });
            }
        }

        /** Mouse Leave */
        else if (event.type === "mouseleave") {
            if (flag === 'Popover-Div') {
                this.setState({ disableOptionPopoverClose: false });
            }
            setTimeout(() => {
                if (!this.state.disableOptionPopoverClose) {
                    this.setState({ optionsPopoverShow: false });
                }
            }, 1500);
        }
    }

    navigate = (event, location) => {
        let classList = [...event?.target?.classList];
        const check = classList.length > 0 && (classList.includes('custom-control-label') || classList.includes('custom-control-input'));
        if (!check) {
            const data = {
                locationList: this.state.locationList,
                stateList: this.state.stateList,
                nextList: this.state.nextList,
                filterLoading: this.state.filterLoading,
                locationFilterForm: this.state.locationFilterForm,
                formValid: this.state.formValid,
                loaderForMore: this.state.loaderForMore,
                cityList: this.state.cityList,
                clearLoading: this.state.clearLoading,
                filterApplied: this.state.filterApplied,
                isVisible: this.state.isVisible,
                pageClientWidth: this.state.pageClientWidth,
                scrollTo: this.state.scrollTo,
                saleCount: this.state.saleCount
            };
            convertToMaintainData(locationList, data);
            const url = location.locationcode ? `/estate-sales/${location.locationstatecode}/${location.locationcode}` : `/estate-sales/${location.locationstatecode}`;
            this.props.history.push(url);
        }
    }

    getMoreList = () => {
        this.setState({
            loaderForMore: true
        }, () => {
            this.filterLocation(true);
        })
    }

    filterLocation = (append = false) => {
        const value = this.state.locationFilterForm;
        const postData = {
            "sort": [{ "field": "title", "direction": "asc" }],
            "page": this.state.nextList && append ? { "size": 48, "next": this.state.nextList } : { 'size': 48 },
            "field": ["id", "title", "contactname", "email", "salecount", "phone", "imageurl", "locationstatecode", "locationcode"]
        };

        const filter = [];
        if (value.location.value !== 'All') {
            filter.push({ "field": "state", "value": value.location.value, "op": "=", "join": "AND" });
        }

        if (value.city.value !== 'All') {
            filter.push({ "field": "city", "value": value.city.value, "op": "=", "join": "AND" });
        }

        if (value.zipcode.value) {
            // filter.push({ "field": "zipcode", "value": value.zipcode.value, "op": "=", "join": "AND" });
            filter.push({ "field": "zip", "value": value.zipcode.value, "op": "=", "join": "AND" });
        }
        if(value.zipcode.value || (value.location.value !== 'All' && value.city.value !== 'All')){
            filter.push({ "field": "miles", "value": value.miles.value, "op": "=", "join": "AND" });
        }
        if (value.loctitle.value) {
            filter.push({ "field": "title", "value": "%" + value.loctitle.value + "%", "op": "LIKE", "join": "AND" });
        }

        if (this.state.saleCount) {
            filter.push({ "field": "salecount", "value": 0, "op": ">", "join": "AND" })
        }

        if (filter.length > 0) {
            postData["filter"] = filter;
        }

        if (value.name.value) {
            const field = [
                { name: 'name-a-z', field: 'title', direction: 'asc' },
                { name: 'name-z-a', field: 'title', direction: 'desc' },
                { name: 'seller-name-a-z', field: 'contactname', direction: 'asc' },
                { name: 'seller-name-z-a', field: 'contactname', direction: 'desc' }
            ];
            const nameValue = field.filter(x => x.name === value.name.value);
            postData['sort'] = [{ "field": nameValue[0].field, "direction": nameValue[0].direction }];
        }

        LocationService.getLocationList(postData).then(
            locationList => {

                const temp = locationList.data.page && locationList.data.page.keyset && locationList.data.page.keyset.next ? locationList.data.page.keyset.next : null;
                let tempList = append ? this.state.locationList : [];
                tempList = tempList.concat(locationList.data.data);
                this.setState({
                    locationList: tempList,
                    filterLoading: false,
                    nextList: temp,
                    loaderForMore: false,
                    clearLoading: false,
                });

            }
        ).catch((error) => {
            // TODO: Error message handle
            this.setState({
                locationList: [],
                filterLoading: false,
                nextList: null,
                loaderForMore: false
            });
        });
    }

    getProfileImage = (location) => {
        const locationImage = {};
        if (location.imageurl) {
            const image = location.imageurl.split(',');
            image.forEach(x => {
                const temp = x.split('#*#');
                locationImage[temp[0]] = temp[1];
            });
        }
        return locationImage.profile ? locationImage.profile : image_thumbnail;
    }

    searchEnable = () => {
        this.setState({
            filterApplied: true,
            filterLoading: true,
        }, () => {
            this.filterLocation();
        });
    }

    clearSearch = () => {
            this.setState({
                nextList: null,
                clearLoading: true,
                cityList: [],
                filterApplied: false,
                locationFilterForm: Object.assign({}, this.locationFilterForm),
                saleCount: false
            }, () => {
                this.filterLocation();
            });

    }

    scrollToTop = () => {
        this.scrollRef.current.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

    /* Called when scroll content */
    handleScroll = (event) => {
        try {
            this.setState({
                isVisible: (event.target.scrollHeight / 4) < event.target.scrollTop,
                scrollTo: event.target.scrollTop,
                pageClientWidth: this.scrollRef?.current?.clientWidth
            });
        } catch (e) {
            this.setState({
                isVisible: false
            });
        }
    };

    resizeHandle = () => {
        this.setState({
            pageClientWidth: this.scrollRef?.current?.clientWidth
        });
    }

    favoriteLocation = (event, location) => {
        event.stopPropagation();
        event.preventDefault();
        const value = event.target.checked;
        if (isAuthorized()) {
            this.setState({
                locationInProgress: {
                    ...this.state.locationInProgress,
                    [location.id]: true
                }
            }, () => {
                if (value) {
                    this.addFavoriteLocation(location);
                } else {
                    this.removeFavoriteLocation(location);
                }
            });
        } else {
            this.signIn();
        }
    }

    signIn = () => {
        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In' } });
    }

    isFavoriteLocation = (location) => {
        return this.state.favoriteLocations.findIndex(x => x.locationid === location.id) > -1;
    }


    addFavoriteLocation = (location) => {
        const postData = { "data": { "locationid": location.id } };
        LocationService.addFavoriteLocation(postData).then(res => {
            const favoriteLocations = this.state.favoriteLocations;
            const data = res.data.data[0];
            data['buyerid'] = this.props.user.id;
            favoriteLocations.push(data);
            this.setState({
                favoriteLocations,
                locationInProgress: {
                    ...this.state.locationInProgress,
                    [location.id]: false
                }
            });
        }).catch(error => {
            this.setState({
                locationInProgress: {
                    ...this.state.locationInProgress,
                    [location.id]: false
                }
            });
        });
    }

    removeFavoriteLocation = (location) => {
        const favoriteLocations = this.state.favoriteLocations;
        const locationData = favoriteLocations.findIndex(x => x.locationid === location.id);
        const postData = { "data": { "locationIds": [{ "id": location.id }] } };
        LocationService.deleteFavoriteLocation(postData).then(res => {
            favoriteLocations.splice(locationData, 1);
            this.setState({
                favoriteLocations,
                locationInProgress: {
                    ...this.state.locationInProgress,
                    [location.id]: false
                }
            });
        }).catch(error => {
            this.setState({
                locationInProgress: {
                    ...this.state.locationInProgress,
                    [location.id]: false
                }
            });
        });
    }

    onCheckboxChange = (e) => {
        this.setState({
            saleCount: e.target.checked ? true : false
        })
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeHandle);
    }

    render() {
        return (
            <div className="locations-list-main" onScroll={this.handleScroll} ref={this.scrollRef}>
                <Helmet>
                    <title>CTBids | Locations</title>
                </Helmet>
                {
                    this.state.pageLoading ?
                        <div className="loader d-flex align-items-center justify-content-center">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                        </div> : <div className="locations-list h-100">
                            <div className="top-header h5">
                                <div className={`d-flex align-items-center justify-content-center`}>
                                    <div className="location-large-screen-width">
                                        Search by Location to View and Bid on Unique and Everyday Treasures
                                    </div>
                                </div>
                            </div>
                            <div className="filter-section">
                                <div className={`d-flex align-items-center justify-content-center`}>
                                    <div className="location-large-screen-width">
                                        <div className="d-lg-flex align-items-start justify-content-between">
                                            <div className="sort-by d-flex align-items-center">
                                                <div className="title">Sort by</div>
                                                <Form.Group controlId="Sort.LocationControlSelect">
                                                    <Form.Control as="select" name="name" aria-label="select location" onChange={this.onInputValidation} value={this.state.locationFilterForm.name.value}>
                                                        <option value="name-a-z">Location Name A-Z</option>
                                                        <option value="name-z-a">Location Name Z-A</option>
                                                        <option value="seller-name-a-z">Seller Name A-Z</option>
                                                        <option value="seller-name-z-a">Seller Name Z-A</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </div>
                                            <div>
                                                <div className="items-select d-flex align-items-center">
                                                    <div className="title">Location</div>
                                                    <Form.Group controlId="loctitle">
                                                        <Form.Control type="text" placeholder="Enter Location" aria-label="enter location" name="loctitle" value={this.state.locationFilterForm.loctitle.value}  onChange={this.onInputValidation}/>
                                                    </Form.Group>
                                                </div>
                                                {
                                                    this.state.locationFilterForm.loctitle.value && this.state.locationFilterForm.loctitle.error ? <small className="text-danger">{this.state.locationFilterForm.loctitle.error}</small> : null
                                                }
                                            </div>
                                            <div className="items-select d-flex align-items-center">
                                                <div className="title">State</div>
                                                <Form.Group controlId="Items.StateControlSelect">
                                                    <Form.Control as="select" name="location" aria-label="select location" onChange={this.onInputValidation} value={this.state.locationFilterForm.location.value}>
                                                        <option value="All">All</option>
                                                        {
                                                            this.state.stateList.map((state, index) => <option key={`state_${index}`} value={state.state}>{state.state}</option>)
                                                        }

                                                    </Form.Control>
                                                </Form.Group>
                                            </div>
                                            <div className="items-select d-flex align-items-center">
                                                <div className="title">City</div>
                                                <Form.Group controlId="Items.CityControlSelect">
                                                    <Form.Control as="select" name="city" aria-label="select city" className="city-in" onChange={this.onInputValidation} value={this.state.locationFilterForm.city.value}>
                                                        <option value="All">All</option>
                                                        {
                                                            this.state.cityList.map((city, index) => <option key={`city_${index}`} value={city.city}>{city.city}</option>)
                                                        }

                                                    </Form.Control>
                                                </Form.Group>
                                            </div>
                                            <div>
                                                <div className="items-select d-flex align-items-center">
                                                    <div className="title">Zipcode</div>
                                                    <Form.Group controlId="zipcode">
                                                        <Form.Control type="text" aria-label="enter zip code" placeholder="Enter Zip code" name="zipcode" value={this.state.locationFilterForm.zipcode.value} onChange={this.onInputValidation} />
                                                    </Form.Group>
                                                </div>
                                                {
                                                    this.state.locationFilterForm.zipcode.value && this.state.locationFilterForm.zipcode.error ? <small className="text-danger">{this.state.locationFilterForm.zipcode.error}</small> : null
                                                }
                                            </div>
                                            <div className="items-select d-flex align-items-center">
                                                <div className="title">Miles</div>
                                                <Form.Group controlId="Items.MilesControlSelect">
                                                    <Form.Control as="select" name="miles" aria-label="select miles" className="miles-in" onChange={this.onInputValidation} value={this.state.locationFilterForm.miles.value}>
                                                        <option value="5">5 Miles</option>
                                                        <option value="10">10 Miles</option>
                                                        <option value="25">25 Miles</option>
                                                        <option value="50">50 Miles</option>
                                                        <option value="100">100 Miles</option>
                                                        <option value="250">250 Miles</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </div>

                                        </div> 
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="checkbox-ml-10">
                                                <Form.Group className="multiple-checkbox checkbox-bottom mb-1">
                                                    <Form.Check custom type="checkbox" id="saleCount" name="saleCount" label="Show locations with Active Sales" checked={this.state.saleCount} onChange={(e) => {this.onCheckboxChange(e)}}/>
                                                </Form.Group>
                                            </div>
                                            <div className="search-button d-flex justify-content-end align-items-center mr-10">
                                                <div className="mx-3">
                                                    <div className="clickable" style={{color:'white'}} onClick={this.clearSearch}>
                                                        {
                                                            this.state.clearLoading ?
                                                                <Spinner animation="border" as="span" size="sm" role="status" aria-hidden="true" />
                                                                : null
                                                        } Clear All
                                                    </div>
                                                </div>
                                            <Button className='location-search' variant="secondary" disabled={this.state.filterLoading} onClick={() => this.searchEnable()}>
                                                    Search {
                                                        this.state.filterLoading ?
                                                            <Spinner animation="border" as="span" size="sm" role="status" aria-hidden="true" />
                                                            : null
                                                    }
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={`list-section ${this.state.locationList.length === 0 ? 'h-75' : ''}`}>
                                <div className={`d-flex align-items-center justify-content-center ${this.state.locationList.length === 0 ? 'h-75' : ''}`}>
                                    <div className="location-large-screen-width">
                                        {
                                            this.state.locationList.length === 0 ?
                                                <div className="no-data-found">
                                                    <div className="text-center no-data-search-icon">
                                                        <i className="fas fa-search fa-3x"></i>
                                                    </div>
                                                    <div className="text-center h4 text-bold">
                                                        No results found
                                                    </div>
                                                    <div className="text-center text-muted h5">
                                                        We couldn't find what you're looking for.
                                                    </div>
                                                </div> : null
                                            //     <Form.Group controlId="formBasicCheckbox" className="live-sale">
                                            //     <Form.Check type="checkbox" label="Only Show Locations with Active Sales" />
                                            // </Form.Group>
                                        }
                                        <Row xs={1} sm={1} md={1} lg={2} className="mt-3">
                                            {
                                                this.state.locationList.map((location, index) => 
                                                    <>
                                                    
                                                    { ADSENSE.ENABLE && index % 8 === 0 && index !== 0 ? <Adsense googleAdCenter slotId={ADSENSE.LOCATION.slotId} /> : '' }

                                                    <Col key={`location_${index}`}>
                                                            <div className="content-container d-flex clickable" onClick={(event) => { this.navigate(event, location) }}>
                                                                <div className="left-side d-flex align-items-center justify-content-center">
                                                                    <img className="location-image" src={this.getProfileImage(location)} alt="location-image"></img>
                                                                </div>
                                                                <div className="right-side">
                                                                    <div className={`d-flex align-items-center justify-content-between header ${!location.salecount || location.salecount === 0 ? 'zero-sale' : ''}`}>
                                                                        <div style={{width:'85%'}}>{location.title}</div>
                                                                        <div>Sales {location.salecount ? location.salecount : 0}</div>
                                                                    </div>
                                                                    <div className="details d-flex flex-column align-items-start justify-content-center">
                                                                        <div className="name">{location.contactname}</div>
                                                                        <div className="email">{location.email}</div>
                                                                        <div>{location.phone}</div>

                                                                    </div>
                                                                    <div className="d-flex align-items-center justify-content-between">
                                                                        <div className="d-flex align-items-center">
                                                                            <Col xs="auto" className="my-1">
                                                                                <Form.Check onChange={(event) => { this.favoriteLocation(event, location) }}
                                                                                    checked={this.isFavoriteLocation(location)}
                                                                                    type="checkbox"
                                                                                    id={`customControlAutosizing${location.id}`}
                                                                                    label="Favorite Location"
                                                                                    className='favorite-checkbox'
                                                                                    disabled={this.state.locationInProgress[location.id] || this.state.updateAllFavoriteLocations}
                                                                                    custom
                                                                                />
                                                                            </Col>
                                                                            {
                                                                                this.state.locationInProgress[location.id] ?
                                                                                    <Spinner animation="border" variant="danger" /> : null
                                                                            }
                                                                        </div>
                                                                        <div className="arrow-right clickable" onClick={(event) => { this.navigate(event, location) }}>
                                                                            <i className="fas fa-long-arrow-alt-right"></i>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                    </Col>
                                                    </>
                                                )
                                            }
                                        </Row>

                                    </div>

                                </div>
                                {
                                    this.state.isVisible ?
                                        <div className="scroll-top d-flex align-items-center justify-content-center clickable" style={{ right: `${window.innerWidth - this.state.pageClientWidth}px` }} onClick={this.scrollToTop}>
                                            <i className="fas fa-arrow-up"></i>
                                        </div> : null
                                }
                                {
                                    this.state.nextList ?
                                        <div className="d-flex justify-content-center">
                                            <div className={`browse-all clickable ${this.state.nextList ? '' : 'custom-disable'} ${this.state.loaderForMore ? 'custom-disable' : ''}`} onClick={this.getMoreList}>
                                                More  {this.state.loaderForMore ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                                            </div>
                                        </div> : null
                                }
                            </div>
                            {!this.props.user.membershipCompleted ?
                                    <div className='w-100' style={{ justifyContent: 'center', alignItems:' center', display: 'flex',  }}>
                                    {bannerImage(this.props, 'Premier-BannerAd-Locations-Unlock3')}
                                </div> : ''}
                        </div>
                }
            </div>
        );
    }
}

export default connect(state => state)(LocationsList);